import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import axios from "axios";
import { Toaster } from "sonner";

import Layout from "./components/site/Layout";
import Home from "./pages/Home";
import Services from "./pages/Services";
import ServiceDetail from "./pages/ServiceDetail";
import Commercial from "./pages/Commercial";
import Gallery from "./pages/Gallery";
import About from "./pages/About";
import Process from "./pages/Process";
import Reviews from "./pages/Reviews";
import FAQ from "./pages/FAQ";
import ServiceAreasPage from "./pages/ServiceAreasPage";
import CityDetail from "./pages/CityDetail";
import Contact from "./pages/Contact";
import ThankYou from "./pages/ThankYou";
import Admin from "./pages/Admin";
import MetaLanding from "./pages/MetaLanding";
import MetaThankYou from "./pages/MetaThankYou";
import Analytics from "./components/site/Analytics";

axios.defaults.withCredentials = true;

function App() {
  return (
    <div className="App selection:bg-[#C69453] selection:text-black">
      <BrowserRouter>
        <Analytics />
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/services/:slug" element={<ServiceDetail />} />
            <Route path="/commercial" element={<Commercial />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/about" element={<About />} />
            <Route path="/process" element={<Process />} />
            <Route path="/reviews" element={<Reviews />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/service-areas" element={<ServiceAreasPage />} />
            <Route path="/service-areas/:slug" element={<CityDetail />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/thank-you" element={<ThankYou />} />
          </Route>
          <Route path="/admin" element={<Admin />} />
          <Route path="/lp/meta" element={<MetaLanding />} />
          <Route path="/lp/meta/thank-you" element={<MetaThankYou />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" theme="dark" closeButton richColors />
    </div>
  );
}

export default App;
